"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EdgeIntersection = _interopRequireDefault(require("./EdgeIntersection"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _Label = _interopRequireDefault(require("./Label"));

var _Edge = _interopRequireDefault(require("./Edge"));

var _TreeMap = _interopRequireDefault(require("../../../../java/util/TreeMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EdgeIntersectionList =
/*#__PURE__*/
function () {
  function EdgeIntersectionList() {
    _classCallCheck(this, EdgeIntersectionList);

    EdgeIntersectionList.constructor_.apply(this, arguments);
  }

  _createClass(EdgeIntersectionList, [{
    key: "print",
    value: function print(out) {
      out.println("Intersections:");

      for (var it = this.iterator(); it.hasNext();) {
        var ei = it.next();
        ei.print(out);
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._nodeMap.values().iterator();
    }
  }, {
    key: "addSplitEdges",
    value: function addSplitEdges(edgeList) {
      this.addEndpoints();
      var it = this.iterator();
      var eiPrev = it.next();

      while (it.hasNext()) {
        var ei = it.next();
        var newEdge = this.createSplitEdge(eiPrev, ei);
        edgeList.add(newEdge);
        eiPrev = ei;
      }
    }
  }, {
    key: "addEndpoints",
    value: function addEndpoints() {
      var maxSegIndex = this.edge.pts.length - 1;
      this.add(this.edge.pts[0], 0, 0.0);
      this.add(this.edge.pts[maxSegIndex], maxSegIndex, 0.0);
    }
  }, {
    key: "createSplitEdge",
    value: function createSplitEdge(ei0, ei1) {
      var npts = ei1.segmentIndex - ei0.segmentIndex + 2;
      var lastSegStartPt = this.edge.pts[ei1.segmentIndex];
      var useIntPt1 = ei1.dist > 0.0 || !ei1.coord.equals2D(lastSegStartPt);

      if (!useIntPt1) {
        npts--;
      }

      var pts = new Array(npts).fill(null);
      var ipt = 0;
      pts[ipt++] = new _Coordinate.default(ei0.coord);

      for (var i = ei0.segmentIndex + 1; i <= ei1.segmentIndex; i++) {
        pts[ipt++] = this.edge.pts[i];
      }

      if (useIntPt1) pts[ipt] = ei1.coord;
      return new _Edge.default(pts, new _Label.default(this.edge._label));
    }
  }, {
    key: "add",
    value: function add(intPt, segmentIndex, dist) {
      var eiNew = new _EdgeIntersection.default(intPt, segmentIndex, dist);

      var ei = this._nodeMap.get(eiNew);

      if (ei !== null) {
        return ei;
      }

      this._nodeMap.put(eiNew, eiNew);

      return eiNew;
    }
  }, {
    key: "isIntersection",
    value: function isIntersection(pt) {
      for (var it = this.iterator(); it.hasNext();) {
        var ei = it.next();
        if (ei.coord.equals(pt)) return true;
      }

      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeIntersectionList;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return EdgeIntersectionList;
}();

exports.default = EdgeIntersectionList;

EdgeIntersectionList.constructor_ = function () {
  this._nodeMap = new _TreeMap.default();
  this.edge = null;
  var edge = arguments[0];
  this.edge = edge;
};